import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e1b92b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "image-wrap em-container" }
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src"]

import { computed } from 'vue'
import Header from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'rules-page',
  setup(__props) {

const imageNumbers = '12345'.split('')
const imageItems = computed(() => {
  return imageNumbers.map((item) => {
    const original = `https://static.knowledge.xag.cn/img/old-brings-new/rules_page/activity-0226_0${item}.jpg`
    const webp = `${original}?imageMogr2/format/webp`
    return { original, webp }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      title: "活动说明",
      rightUseSlot: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageItems), (item) => {
          return (_openBlock(), _createElementBlock("picture", {
            key: item.original,
            class: "image-item"
          }, [
            _createElementVNode("source", {
              srcset: item.webp,
              type: "image/webp"
            }, null, 8, _hoisted_3),
            _createElementVNode("img", {
              src: item.original,
              alt: ""
            }, null, 8, _hoisted_4)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})